import { useEffect } from "react";
import { useAuthStore } from "@/stores/auth";
import { useProductTourStore } from "@/stores/productTour";
import { emptyTourState } from "@/lib/productTour";

export function useProductTour() {
  const userId = useAuthStore((s) => s.user?.id ?? null);
  const store = useProductTourStore();
  const initialize = store.initialize;
  useEffect(() => { void initialize(userId); }, [userId, initialize]);
  useEffect(() => {
    const retry = () => { void useProductTourStore.getState().retry(); };
    const focus = () => { if (document.visibilityState === "visible") retry(); };
    window.addEventListener("online", retry);
    document.addEventListener("visibilitychange", focus);
    return () => { window.removeEventListener("online", retry); document.removeEventListener("visibilitychange", focus); };
  }, []);
  // Account changes never expose the previous account's cached progress.
  return store.ownerId === userId ? store : { ...store, state: emptyTourState(), ready: false };
}
